<template>
  <app-communications />
</template>

<script>
import AppCommunications from "./../components/app/communications/AppCommunications.vue";

export default {
  name: "Communications",
  components: {
    AppCommunications,
  },
};
</script>
